import { Component } from '@angular/core';
import { NavController, ModalController, AlertController, PopoverController } from 'ionic-angular';

import { LoadingPage } from '../loading/loading';

import { DropdownPopoverPage } from '../dropdown-popover/dropdown-popover';
import { DropdownDatePage } from '../dropdown-date/dropdown-date';

import { DataProvider } from '../../providers/data/data';
import { ConstantsProvider } from '../../providers/constants/constants';
import { CloudDataProvider } from '../../providers/cloud-data/cloud-data';

@Component({
   selector: 'page-edit-info',
   templateUrl: 'edit-info.html'
})

export class EditInfoPage
{

   private lastnameZh = '';
   private firstnameZh = '';
   private firstnameEn = '';
   private lastnameEn = '';
   private gender = 'M';
   private dob = '1900-01-01';
   private marital = 'married';
   private smoker = '0';
   private remark = '';

   private mr_main = '';
   private mr_symptom = '';
   private mr_allergy = '';
   private mr_nose = '';
   private mr_skin = '';
   private mr_medicine = '';
   private mr_food = '';
   private mr_gen_disease = '';
   private mr_chronic = '';
   private mr_diabetes = '';
   private mr_cholesterol = '';

   private mr_menstrual_history = '';
   private mr_pms = '';
   private mr_dysmenorrhea = '';
   private mr_others = '';

   /** ----- Constructor ----- **/

   constructor( private data: DataProvider,
                private constants: ConstantsProvider,
                private cloudData: CloudDataProvider,
                private navCtrl: NavController,
                private modalCtrl: ModalController,
                private alertCtrl: AlertController,
                private popoverCtrl: PopoverController )
   {

      this.lastnameZh = data.selectedPatient[ 'pat_lastname_zh' ];
      this.firstnameZh = data.selectedPatient[ 'pat_firstname_zh' ];
      this.firstnameEn = data.selectedPatient[ 'pat_firstname_en' ];
      this.lastnameEn = data.selectedPatient[ 'pat_lastname_en' ];
      this.gender = data.selectedPatient[ 'pat_gender' ];
      this.dob = data.selectedPatient[ 'pat_dob' ];
      this.marital = data.selectedPatient[ 'pat_marital' ];
      this.smoker = data.selectedPatient[ 'pat_smoker' ];
      this.remark = data.selectedPatient[ 'pat_remark' ];

      this.mr_main = constants.selectedMedicals[ 'mr_main' ];
      this.mr_symptom = constants.selectedMedicals[ 'mr_symptom' ];
      this.mr_allergy = constants.selectedMedicals[ 'mr_allergy' ];
      this.mr_nose = constants.selectedMedicals[ 'mr_nose' ];
      this.mr_skin = constants.selectedMedicals[ 'mr_skin' ];
      this.mr_medicine = constants.selectedMedicals[ 'mr_medicine' ];
      this.mr_food = constants.selectedMedicals[ 'mr_food' ];
      this.mr_gen_disease = constants.selectedMedicals[ 'mr_gen_disease' ];
      this.mr_chronic = constants.selectedMedicals[ 'mr_chronic' ];
      this.mr_diabetes = constants.selectedMedicals[ 'mr_diabetes' ];
      this.mr_cholesterol = constants.selectedMedicals[ 'mr_cholesterol' ];

      //extra fields
      this.mr_menstrual_history = constants.selectedMedicals[ 'mr_menstrual_history' ];
      this.mr_pms = constants.selectedMedicals[ 'mr_pms' ];
      this.mr_dysmenorrhea = constants.selectedMedicals[ 'mr_dysmenorrhea' ];
      this.mr_others = constants.selectedMedicals[ 'mr_others' ];
   }


   /** ----- View LifeCycle ----- **/

   onBackClicked()
   {

      let backConfirm = this.alertCtrl.create({
         title    : '返回',
         subTitle : '已輸入的資料將不會被儲存，確認要返回嗎？',
         buttons  : [
            {
               text     : '取消',
               role     : 'cancel'
            },
            {
               text     : '確認',
               handler  : () => {

                  this.navCtrl.pop();
               }
            }
         ],
         enableBackdropDismiss: false
      });
      backConfirm.present();

   }


   onSaveClicked()
   {
      console.log("data.selectedPatien");
      console.log(this.data.selectedPatient);
      // prompt for confirmation
      let saveConfirm = this.alertCtrl.create({
         title    : '儲存更新',
         subTitle : '確認要覆蓋舊的資料嗎？',
         buttons  : [
            {
               text     : '取消',
               role     : 'cancel'
            },
            {
               text     : '確認',
               handler  : () => {


                  // show loading indicator and upsert consultation
                  let loading = this.modalCtrl.create( LoadingPage, {}, { enableBackdropDismiss: false } );
                  loading.present();
                  let params = {
                     'token'              : this.data.token,
                     'pat_id'             : this.data.selectedPatient[ 'pat_id' ],
                     'pat_row_id'         : this.data.selectedPatient[ 'id' ],
                     'pat_lastname_zh'    : this.lastnameZh,
                     'pat_firstname_zh'   : this.firstnameZh,
                     'pat_firstname_en'   : this.firstnameEn,
                     'pat_lastname_en'    : this.lastnameEn,
                     'pat_gender'         : this.gender,
                     'pat_dob'            : this.dob,
                     'pat_marital'        : this.marital,
                     'pat_smoker'         : this.smoker,
                     'pat_remark'         : ( this.remark != '' ) ? this.remark : null,
                     'mr_main'            : ( this.mr_main != '' ) ? this.mr_main : null,
                     'mr_symptom'         : ( this.mr_symptom != '' ) ? this.mr_symptom : null,
                     'mr_menstrual_history': ( this.mr_menstrual_history != '' ) ? this.mr_menstrual_history : null,
                     'mr_pms'         : ( this.mr_pms != '' ) ? this.mr_pms : null,
                     'mr_dysmenorrhea' : ( this.mr_dysmenorrhea != '' ) ? this.mr_dysmenorrhea : null,
                     'mr_allergy'         : ( this.mr_allergy != '' ) ? this.mr_allergy : null,
                     'mr_nose'            : ( this.mr_nose != '' ) ? this.mr_nose : null,
                     'mr_skin'            : ( this.mr_skin != '' ) ? this.mr_skin : null,
                     'mr_medicine'        : ( this.mr_medicine != '' ) ? this.mr_medicine : null,
                     'mr_food'            : ( this.mr_food != '' ) ? this.mr_food : null,
                     'mr_gen_disease'     : ( this.mr_gen_disease != '' ) ? this.mr_gen_disease : null,
                     'mr_chronic'         : ( this.mr_chronic != '' ) ? this.mr_chronic : null,
                     'mr_diabetes'        : ( this.mr_diabetes != '' ) ? this.mr_diabetes : null,
                     'mr_cholesterol'     : ( this.mr_cholesterol != '' ) ? this.mr_cholesterol : null,
                     'mr_others'     : ( this.mr_others != '' ) ? this.mr_others : null
                  };
                  
                  this.cloudData.upsertPatient( params ).then( res => {

                     // dismiss loading indicator and then handle response
                     loading.dismiss();
                     if ( res[ 'status' ] == true )
                     {
                        this.data.selectedPatient = res[ 'result' ][ 'patients' ];
                        let name = ( this.lastnameZh != '' && this.firstnameZh != '' ) ? this.lastnameZh + this.firstnameZh : this.firstnameEn + this.lastnameEn;
                        let success = this.alertCtrl.create({
                           title                : '成功',
                           subTitle             : '已成功更新 ' + name + ' 的資料',
                           buttons              : [
                              {
                                 text     : '確認',
                                 handler  : () => {

                                    this.navCtrl.pop();
                                 }
                              }
                           ],
                           enableBackdropDismiss: false
                        });
                        success.present();
                     }
                     else
                     {
                        // prompt for confirmation
                        let error = this.alertCtrl.create({
                           title                : '上傳失敗',
                           subTitle             : '請稍候再試',
                           buttons              : [
                              {
                                 text     : '確認',
                                 role     : 'cancel'
                              }
                           ],
                           enableBackdropDismiss: false
                        });
                        error.present();
                     }
                  });
                  
               }
            }
         ],
         enableBackdropDismiss: false
      });
      saveConfirm.present();

   }


   onGenderClicked( inEvent )
   {

      let popover = this.popoverCtrl.create( DropdownPopoverPage, { 'choices': [ '男', '女' ], 'callback': this.genderCallback }, { cssClass: 'edit-info-popover' } );
      popover.present({
         ev: inEvent
      });

   }


   genderCallback = ( inIdx ) => {

      return new Promise( ( resolve ) => {

         this.gender = ( inIdx == 0 ) ? 'M' : 'F';
         resolve();
      });
   }


   onDateClicked( inEvent )
   {

      let datePicker = this.popoverCtrl.create( DropdownDatePage, { 'date': ( this.dob == '0000-00-00' ) ? new Date().toString() : this.dob, 'callback': this.dateCallback }, { cssClass: 'custom-popover' } );
      datePicker.present({
         ev: inEvent
      });

   }


   dateCallback = ( inDate ) => {

      return new Promise( resolve => {

         this.dob = inDate;
         resolve();
      });
   }


   onMaritalClicked( inEvent )
   {

      let popover = this.popoverCtrl.create( DropdownPopoverPage, { 'choices': [ '單身', '已婚', '離婚', '寡' ], 'callback': this.maritalCallback }, { cssClass: 'edit-info-popover' } );
      popover.present({
         ev: inEvent
      });

   }


   maritalCallback = ( inIdx ) => {

      return new Promise( ( resolve ) => {

         this.marital = ( inIdx == 0 ) ? 'single' :
                        ( inIdx == 1 ) ? 'married' :
                        ( inIdx == 2 ) ? 'divorced' : 'widowed';
         resolve();
      });
   }


   onSmokerClicked( inEvent )
   {

      let popover = this.popoverCtrl.create( DropdownPopoverPage, { 'choices': [ '吸煙', '不吸煙' ], 'callback': this.smokerCallback }, { cssClass: 'edit-info-popover' } );
      popover.present({
         ev: inEvent
      });

   }


   smokerCallback = ( inIdx ) => {

      return new Promise( ( resolve ) => {

         this.smoker = ( inIdx == 0 ) ? '1' : '0';
         resolve();
      });
   }

}



// WEBPACK FOOTER //
// ./src/pages/edit-info/edit-info.ts